import React from 'react';

import Academies from '@crehana/web/dist/HomeUser/Academies';
import { useIsBrazil } from '@crehana/i18n';
import styled from 'styled-components';

import { CATALOG_AMPLITUDE_PAGE_NAME } from 'Jsx/Catalog/constants';

interface CatalogAcademiesProps {
  title?: string;
  currentCategorySlug?: string[];
  sourceDetail?: string;
}

const Wrapper = styled.div`
  & h4 {
    font-size: 24px !important;
    line-height: 30px !important;
    letter-spacing: 0.1px !important;
  }
`

const CatalogAcademies: React.FC<CatalogAcademiesProps> = ({
  title,
  currentCategorySlug,
  sourceDetail,
}) => {
  const isBrazil = useIsBrazil();

  if (isBrazil) {
    return null;
  }

  return (
    <Wrapper className='tw-w-full'>
      <Academies
        source={CATALOG_AMPLITUDE_PAGE_NAME}
        sourceDetail={sourceDetail}
        title={title}
        catalogCategories={currentCategorySlug}
        itemsPerPage={{ xs: 1, sm: 3, md: 3, lg: 3, xl: 4 }}
        containerProps={{
          fullWidth: true,
        }}
      />
    </Wrapper>
  );
};

export default CatalogAcademies;
